import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';

function loginWithEmailFormatter({ email: userEmail }) {
  return [
    getGTMEventData(EVENT_NAMES.TRACK_USER, userEmail, {}),
    getGTMEventData(EVENT_NAMES.REGISTER_USER, userEmail, {
      authenticationMode: 'email_password', newUser: false,
    }),
  ];
}

export default loginWithEmailFormatter;
